/**
 * RemarkStyleEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { RemarkEntity } from "../RemarkEntity";
import { RemarkStyleEntity } from "../RemarkStyleEntity";
declare global {
    interface EntityTypeMap {
        RemarkStyle: RemarkStyleEntity;
    }
}
export abstract class RemarkStyleGeneratedEntity extends BaseEntity {
    public abstract remarkStyleId: string;
    public abstract templateId: string | null;
    public abstract name: string | null;
    public abstract color: number;
    public abstract style: number | null;
    public abstract isDefault: boolean | null;
    public abstract project: ProjectEntity;
    public abstract readonly styleOfRemark: ReadonlyArray<RemarkEntity>;
}
